<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card class='mb-2'>
                  <v-card-title class="text-xs-center" style="font-size: 2rem">
                    Cadastro de turmas
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap justify-center align-center>
                      <v-container fluid>
                        <v-form v-model="valid" ref="form" lazy-validation >
                          <v-flex xs12>
                            <v-text-field
                            label="*Nome"
                            v-model="turmaData.name"
                            :rules="usernameRules"
                            :error-messages="errors"
                            :counter="100"
                            maxlength="100"
                            @blur="doesNameExists"
                            required
                            ></v-text-field>
                            <v-textarea
                            name="Descricao"
                            v-model="turmaData.description"
                            label="Descrição"
                            :counter="1200"
                            maxlength="1200"
                            ></v-textarea>
                            <v-autocomplete
                            v-if="isMakerlab && secretariaSelect > 0"
                            label="*Unidade"
                            :items="selectUnidade"
                            :error-messages="errou"
                            item-text="name"
                            return-object
                            v-model="local"
                            :rules="[v => !v.id < 1|| 'Unidade é obrigatório']"
                            required
                            max-height="400"
                            hint="Escolha a unidade"
                            persistent-hint
                            ></v-autocomplete>
                            <v-autocomplete
                            v-if="!isMakerlab"
                            label="*Unidade"
                            :items="unidades"
                            item-text="name"
                            return-object
                            v-model="local"
                            :rules="[v => !v.id < 1|| 'Unidade é obrigatório']"
                            required
                            max-height="400"
                            hint="Escolha a unidade"
                            persistent-hint
                            ></v-autocomplete>
                            <v-autocomplete
                            v-if="local.id > 0 && !isMakerlab"
                            label="*Programa"
                            :items="programas"
                            :rules="[v => !!v || 'Programa é obrigatório']"
                            required
                            item-text="name"
                            item-value="name"
                            v-model="turmaData.programa"
                            max-height="400"
                            hint="Escolha o programa"
                            persistent-hint
                            ></v-autocomplete>
                            <v-autocomplete
                              v-if="showAno"
                              label="*Ano"
                              :items="anoOrder"
                              item-text="name"
                              item-value="name"
                              v-model="turmaData.ano"
                              :rules="[v => !!v || 'Ano é obrigatório']"
                              required 
                              max-height="400"
                              hint="Escolha o ano"
                              persistent-hint
                            ></v-autocomplete>
                            <!-- MundoMaker -->
                            <v-layout row wrap style="padding-top: 5px" v-if="!isMakerlab">
                              <v-flex xs6>
                                <v-menu
                                  ref="menu"
                                  lazy
                                  :close-on-content-click="false"
                                  v-model="menu"
                                  transition="scale-transition"
                                  offset-y
                                  :nudge-right="40"
                                  min-width="290px"
                                >
                                  <v-text-field
                                    slot="activator"
                                    label="*Data de inicio"
                                    :rules="[v => !!v || 'Data do fim é obrigatório']"
                                    v-model="computedDateFormatted2"
                                    prepend-icon="event"
                                    readonly
                                  ></v-text-field>
                                  <v-date-picker v-model="turmaData.dt_inicio" no-title scrollable
                                    locale="pt-br">
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.menu.save(turmaData.dt_inicio)">OK</v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs6>
                                <v-menu
                                  ref="menu2"
                                  lazy
                                  :close-on-content-click="false"
                                  v-model="menu2"
                                  transition="scale-transition"
                                  offset-y
                                  :nudge-right="40"
                                  min-width="290px"
                                >
                                  <v-text-field
                                    slot="activator"
                                    label="*Data do fim"
                                    :rules="[v => !!v || 'Data do fim é obrigatório']" 
                                    v-model="computedDateFormatted"
                                    prepend-icon="event"
                                  ></v-text-field>
                                  <v-date-picker v-model="turmaData.dt_fim" no-title scrollable
                                    locale="pt-br">
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="menu2 = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.menu2.save(turmaData.dt_fim)">OK</v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="!isMakerlab">
                              <v-flex xs6>
                                <v-menu
                                  ref="menu3"
                                  lazy
                                  :close-on-content-click="false"
                                  v-model="menu3"
                                  transition="scale-transition"
                                  offset-y
                                  :nudge-right="40"
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <v-text-field
                                    slot="activator"
                                    label="*Selecione o horário"
                                    v-model="turmaData.horario"
                                    prepend-icon="access_time"
                                    :rules="[v => !!v || 'Horário é obrigatório']" 
                                    readonly
                                  ></v-text-field>
                                  <v-time-picker v-model="turmaData.horario"
                                   min="7:00"
                                   max="19:59"
                                   format="24hr"
                                   @change="$refs.menu3.save(turmaData.horario)"></v-time-picker>
                                </v-menu>
                              </v-flex>
                              <v-flex xs6>  
                                <v-text-field 
                                  v-model="turmaData.duracao"
                                  style="width: 18rem"
                                  type="number"
                                  :rules="[v => !!v || 'Duração é obrigatório']"  
                                  label="*Duração"
                                  hint="Em minutos"
                                  persistent-hint
                                  prepend-icon="access_time">
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="!isMakerlab">
                              <v-flex xs6>
                                <v-select
                                  style="margin-top: 30px; width: 18rem"
                                  label="*Periodicidade"
                                  :rules="[v => !!v || 'Periodicidade é obrigatório']" 
                                  :items="freq"
                                  item-text="tipo"
                                  item-value="acron"
                                  v-model="turmaData.tipo"
                                  max-height="400"
                                  hint="Pode ser semanal ou diária"
                                  persistent-hint
                                ></v-select>                      
                              </v-flex>
                              <v-spacer></v-spacer>
                              <v-flex xs6>   
                                <v-select
                                  v-if="turmaData.tipo === 'S'"
                                  style="margin-top: 30px; width: 18rem"
                                  label="*Dia da semana"
                                  :rules="[v => !!v || 'Dia da semana é obrigatório']" 
                                  :items="dias"
                                  item-text="day"
                                  item-value="number"
                                  v-model="turmaData.dia_semana"
                                  max-height="400"
                                  hint="Selecione os dias da semana"
                                  persistent-hint
                                ></v-select>       
                              </v-flex>  
                            </v-layout>
                            <!-- MakerLab -->
                            <v-layout row wrap v-if="isMakerlab">
                              <v-text-field
                                label="Ano letivo"
                                v-model="letivo"
                                required
                                hint="Ano no formato AAAA"
                                mask="####"
                              ></v-text-field>
                            </v-layout>
                          </v-flex>
                        </v-form>
                      </v-container>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn 
                      color="info"
                      :loading="animation"
                      @click="performSave" 
                      :disabled="!valid">
                        <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
                          <span v-else>
                            Enviar
                          </span>
                          </v-btn>
                  </v-card-actions>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'
export default {
  components: {
  },
  data () {
    return {
      turmaData: {
        dia_semana: ''
      },
      currentTab: 'Sobre',
      letivo: '',
      showImageUpload: false,
      imageChangeModal: false,
      selectedFile: {},
      animation: false,
      editing: false,
      tempData: {},
      dt_inicio: null,
      selectUnidade: [],
      secretariaSelect: true,
      dt_fim: null,
      menu: false,
      menu2: false,
      menu3: false,
      modal: false,
      turmanameExists: false,
      time: null,
      horario: null,
      errors: '',
      errou: '',
      usernameRules: [
        v => !!v || 'Nome da turma é obrigatório'
      ],
      dias: [
            {number: '0', day: 'Segunda'},
            {number: '1', day: 'Terça'},
            {number: '2', day: 'Quarta'},
            {number: '3', day: 'Quinta'},
            {number: '4', day: 'Sexta'},
            {number: '5', day: 'Sabado'},
            {number: '6', day: 'Domingo'}
      ],
      dia_semana: [],
      freq: [
            {acron: 'S', tipo: 'Semanal'},
            {acron: 'D', tipo: 'Diária'}
      ],
      options: {},
      programas: [],
      programa: [],
      local: [],
      ano: {},
      showAno: false,
      anoGeral: [],
      unidades: [],
      secretaria: [],
      path: '',
      valid: true,
      loading: false,
      unidadeRules: [
        v => !!(v) || 'Unidade é obrigatória'
      ]
    }
  },
  created () {
    let username = this.$store.state.user.username
    api.request('GET', 'user-edit-options/' + username + '/').then((response) => {
      this.options = response.data
    })
    api.request('GET', 'unidade/').then((response) => {
      this.unidades = response.data
      if (this.$store.state.selectedRole.name === 'Secretaria') {
        this.unidadeSecretaria(this.$store.state.user.id)
      } else {
        this.selectUnidade = this.unidades
      }
    })
    api.request('GET', 'search-user?groups__name=Secretaria').then((response) => {
      this.secretaria = response.data
    })
    api.request('GET', 'ano/').then(response => {
      response.data.sort((a, b) => (a.order_number > b.order_number) ? 1 : ((b.order_number > a.order_number) ? -1 : 0))
      this.anoGeral = response.data
    })
  },
  mounted () {
    this.$watch('local', function () {
      console.log('local', this.local)
      this.turmaData.unidade = this.local.slug
      this.getAno(this.local)
      this.getPrograma(this.local)
    })
    this.$watch('turmanameExists', () => {
      if (this.turmanameExists) {
        this.errors = 'Nome de turma já existe'
      } else {
        this.errors = ''
      }
    })
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.turmaData.dt_fim)
    },
    computedName () {
      if (this.turmanameExists) {
        return true
      } else {
        return false
      }
    },
    computedDateFormatted2 () {
      return this.formatDate(this.turmaData.dt_inicio)
    },
    isMakerlab () {
      return this.$store.state.company.makerlab;
    },
    anoOrder () {
      var order = []
      for (let i = 0; i < this.anoGeral.length; i++) {
        for (let index = 0; index < this.ano.ano.length; index++) {
          if (this.anoGeral[i].name === this.ano.ano[index]) {
            order.push(this.anoGeral[i])
          }
        }
      }
      return order
    }
  },
  // watch: {
  //   date (val) {
  //     this.turmaData.dt_fim = this.formatDate(this.date)
  //   }
  // },
  methods: {
    goToUnidade (unidade) {
      this.$router.push('/unidade/' + unidade)
    },
    unidadeSecretaria (user) {
      this.selectUnidade = this.unidades.filter(v => {
        if (v.secretaria_responsavel === user) {
          this.secretariaSelect = true
          return v
        }
      })
      console.log('length', this.selectUnidade)
      if (this.selectUnidade.length === 0) {
        this.errou = 'Você não é responsável por uma unidade, não poderá cadastrar a turma'
      }
      if (this.selectUnidade.length === 1) {
        this.local = this.selectUnidade[0]
        this.secretariaSelect = false
      }
    },
    doesNameExists () {
      api.request('GET', 'turmas/?name__iexact=' + this.turmaData.name)
        .then(resp => {
          if (resp.data.length >= 1) {
            this.turmanameExists = true
          } else {
            this.turmanameExists = false
          }
          if (this.turmaData.name === '') {
            this.turmanameExists = false
          }

          console.log(this.turmanameExists)
        })
    },
    getAno (local) {
      api.request('GET', 'unidade/' + local.slug + '/').then(response => {
        this.ano = response.data
        console.log('ano', this.ano)
        this.showAno = true
      })
    },
    getPrograma (slug) {
      api.request('GET', 'programas/?unidades__slug=' + slug.slug).then(response => {
        this.programas = response.data
      })
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    performSave () {
      if (this.$refs.form.validate()) {
        this.animation = true
        let self = this
        console.log(self.turmaData)
        if (this.isMakerlab) {
          self.turmaData.programa = this.programas[0].name
          self.turmaData.duracao = '100'
          self.turmaData.horario = '13:00'
          self.turmaData.dt_inicio = self.letivo + '-01-01'
          self.turmaData.dt_fim = self.letivo + '-12-31'
          if (this.local.programa[0] === 'makerlab-quinzenal') {
            self.turmaData.tipo = 'S'
            self.turmaData.dia_semana = '0'
          } else {
            self.turmaData.tipo = 'D'
          }
        }
        api.request('POST', 'turmas/', self.turmaData).then(response => {
          if (response.status === 201) {
            console.log(response.data)
            let name = '/turmas/' + response.data.slug
            self.animation = false
            self.$router.push(name)
          } else {
            console.log(response)
            self.animation = false
          }
        }).catch(function (error) {
          console.log(error)
          self.animation = false
        })
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Turmas/Cadastro.vue